export const TUITION_COPY = {
	welcome: 'Access Your Tuition Payment',
	description: 'Enter your student email to view available program payment links.',
	admitted: 'Congratulations on being admitted to Leangap!',
	notFound:
		"We couldn't find a student with this email. Please make sure you're using the email address the student used to apply.",
	notAdmittedYet:
		'This student is not currently admitted. Please contact us at contact@leangap.org if you think this is a mistake.',
	error: 'An error occurred while checking your status. Please try again.',
}

export type ProgramOption = {
	id: string
	label: string
	url: string
	disabled?: boolean
	badge?: string
}

export const TUITION_PROGRAMS: ProgramOption[] = [
	{
		id: 'online',
		label: 'Online',
		url: 'https://enroll.leangap.org/checkout/online',
	},
	{
		id: 'sf',
		label: 'San Francisco',
		url: 'https://enroll.leangap.org/checkout/san-francisco',
	},
	{
		id: 'next-year',
		label: 'San Francisco 2028',
		url: 'https://enroll.leangap.org/checkout/san-francisco-2028',
	},
]

export default { TUITION_COPY, TUITION_PROGRAMS }
